export const POPULATE_SESSION = 'populateSession';
export const OTHER = 'other';
